import { cn } from '@rocco/utils/cn';

import { SelectedItemMedia } from './SelectedItemMedia';
import type { BulkEnquiryItem } from './bulk-enquiry-state';

interface SelectedItemsThumbnailsProps {
    items: BulkEnquiryItem[];
    className?: string;
}

/** Beyond this the remaining items collapse into a "+N" disc. */
const MAX_THUMBNAILS = 5;

/**
 * The selection as a stack of overlapping thumbnails — a compact reminder of
 * what is being enquired about, for surfaces that don't have room for the full
 * {@link SelectedItemsList} (the modal's form step).
 */
export const SelectedItemsThumbnails = ({
    items,
    className,
}: SelectedItemsThumbnailsProps) => {
    if (items.length === 0) return null;

    const shown = items.slice(0, MAX_THUMBNAILS);
    const overflow = items.length - shown.length;

    return (
        <div
            className={cn('flex shrink-0 items-center -space-x-3', className)}
            aria-hidden
        >
            {shown.map((item) => (
                <SelectedItemMedia
                    key={item.siteTreeID}
                    item={item}
                    className="size-12 rounded-full border-2 border-white"
                />
            ))}
            {overflow > 0 ? (
                <div className="flex size-12 items-center justify-center rounded-full border-2 border-white bg-gray-800 text-sm font-medium text-white">
                    {`+${overflow}`}
                </div>
            ) : null}
        </div>
    );
};
